import { createIcon } from '@chakra-ui/react';

export const Biology = createIcon({
  displayName: `Biology`,
  viewBox: `0 0 45.155 45.155`,
  path: (
    <g transform="translate(-1016.417 575.143)">
      <path
        d="M1050.26-573.375c-7.226,7.057,3.414,20.395-4.467,27.369l-.19.148c-7.142,7.142-20.353-3.655-27.42,4.142"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <path
        d="M1034.667-526.418c7.226-7.057-3.413-20.395,4.467-27.369l.19-.148c7.142-7.142,20.353,3.655,27.42-4.142"
        transform="translate(-4.53 -4.204)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="7.068"
        y1="6.86"
        transform="translate(1053.676 -567.837)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="4.016"
        y1="3.897"
        transform="translate(1031.502 -570.546)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="4.769"
        y1="4.552"
        transform="translate(1043.927 -555.794)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="4.769"
        y1="4.552"
        transform="translate(1031.837 -553.124)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="4.695"
        y2="4.809"
        transform="translate(1048.333 -566.718)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="4.695"
        y2="4.809"
        transform="translate(1036.605 -570.546)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="4.016"
        y1="3.897"
        transform="translate(1053.907 -552.921)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="4.695"
        y2="4.809"
        transform="translate(1059.011 -552.921)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="7.361"
        y1="7.144"
        transform="translate(1023.437 -539.049)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="4.695"
        y2="4.809"
        transform="translate(1024.004 -544.565)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x2="11.572"
        y2="11.54"
        transform="translate(1034.604 -557.992)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </g>
  ),
});
